/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './ProDashboard.css';
import BookingWidget from './partials/BookingWidget';
import {
  fetchUser,
  listCompanies,
} from '../actions';


class ProWidget extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['companies', listCompanies, p => { return [{ mine: 1 }] }],
  ]

  renderWidget() {
    let companies = this.props.companies;
    if (!companies) return;

    let company = companies.items[0];
    let nodes = company.locations.map(location => <BookingWidget
                                                    key={location.id}
                                                    locationId={location.id}
                                                  />);

    return (
      <div>
        {nodes}
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="ProWidget" padded pro>
        <div className="pro-header">Booking Widget</div>

        {this.renderWidget()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    companies: state.list.company,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProWidget);



/** WEBPACK FOOTER **
 ** ./src/components/ProWidget.js
 **/